import React from 'react';
import { framework_tool } from '@/tool'
import { QsPreview } from '@/components'
const { WizContainer } = framework_tool;
import mockData from './data.json'

// const data = {
//     title: '社交网站满意度调查',//问卷名称
//     type: 1,//问卷类型
//     img: '',//问卷图片
//     intro: '尊敬的xx社交网站用户，您好！为了给您提供更好的服务，希望您能抽出几分钟时间，将您的感受和建议告诉我们，我们非常重视每位用户的宝贵意见，期待您的参与。现在我们就马上开始吧！',//问卷说明
//     questions: [
//         {
//             id: 1,
//             type: 0,//题目类型 0单选题 1多选题 2下拉题 3填空题 4单行文本题 5多行文本题 6评分题
//             title: '你的性别是？',//题干
//             img: '',//题目图片
//             tips: '',//题干提示信息
//             required: 1,//是否必填 0不必填 1必填
//             allowOther: 0,//是否允许其他答案 0不允许 1允许
//             otherDescribe: '其他（请注明）',//其他答案提示信息
//             value: 1,
//             options: [
//                 {
//                     id: 0,
//                     content: '男',
//                     img: ''
//                 },
//                 {
//                     id: 1,
//                     content: '女',
//                     img: ''
//                 }
//             ]
//         },
//         {
//             id: 2,
//             type: 1,//题目类型 0单选题 1多选题 2下拉题 3填空题 4单行文本题 5多行文本题 6评分题
//             title: '请问，您使用xx社交网站的目的是？',//题干
//             img: '',//题目图片
//             tips: '',//题干提示信息
//             required: 0,//是否必填 0不必填 1必填
//             allowOther: 1,//是否允许其他答案 0不允许 1允许
//             otherDescribe: '其他（请注明）',//其他答案提示信息
//             value: [2, 3, 4, -1],
//             otherAnswer: '陶冶情操',
//             options: [
//                 {
//                     id: 2,
//                     content: '打发时间',
//                     img: ''
//                 },
//                 {
//                     id: 3,
//                     content: '体验各种有趣的游戏和应用',
//                     img: ''
//                 },
//                 {
//                     id: 4,
//                     content: '方便与朋友联系，分享乐趣',
//                     img: ''
//                 },
//                 {
//                     id: 5,
//                     content: '有机会结交更多的朋友',
//                     img: ''
//                 },
//                 {
//                     id: 6,
//                     content: '寻找志趣相投的群体',
//                     img: ''
//                 }
//             ]
//         },
//         {
//             id: 3,
//             type: 2,//题目类型 0单选题 1多选题 2下拉题 3填空题 4单行文本题 5多行文本题 6评分题
//             title: '您的出生年份是？',//题干
//             img: '',//题目图片
//             tips: '',//题干提示信息
//             required: 1,//是否必填 0不必填 1必填
//             allowOther: 0,//是否允许其他答案 0不允许 1允许
//             otherDescribe: '其他（请注明）',//其他答案提示信息
//             value: '2020',
//             options: [
//                 {
//                     id: 2000,
//                     content: '2000',
//                     img: ''
//                 },
//                 {
//                     id: 2001,
//                     content: '2001',
//                     img: ''
//                 },
//                 {
//                     id: 2002,
//                     content: '2002',
//                     img: ''
//                 },
//                 {
//                     id: 2003,
//                     content: '2003',
//                     img: ''
//                 }
//             ]
//         },
//         {
//             id: 4,
//             type: 3,//题目类型 0单选题 1多选题 2下拉题 3填空题 4单行文本题 5多行文本题 6评分题
//             title: '你是一个____的人？',//题干
//             img: '',//题目图片
//             tips: '',//题干提示信息
//             value: '耿直不善言辞',
//             required: 0//是否必填 0不必填 1必填
//         },
//         {
//             id: 5,
//             type: 4,//题目类型 0单选题 1多选题 2下拉题 3填空题 4单行文本题 5多行文本题 6评分题
//             title: '单行文本题,请输入你要说的一句话',//题干
//             img: '',//题目图片
//             tips: '',//题干提示信息
//             value: '好好学习，天天向上。',
//             required: 0//是否必填 0不必填 1必填
//         },
//         {
//             id: 6,
//             type: 5,//题目类型 0单选题 1多选题 2下拉题 3填空题 4单行文本题 5多行文本题 6评分题
//             title: '多行文本题,请输入你要说的一段话',//题干
//             img: '',//题目图片
//             tips: '',//题干提示信息
//             value: '我没什么要说的',
//             required: 0//是否必填 0不必填 1必填
//         },
//         {
//             id: 7,
//             type: 6,//题目类型 0单选题 1多选题 2下拉题 3填空题 4单行文本题 5多行文本题 6评分题
//             title: '请给本项打分',//题干
//             img: '',//题目图片
//             tips: '',//题干提示信息
//             value: '3.5',
//             required: 0//是否必填 0不必填 1必填
//         }
//     ]
// }


class questionResult extends WizContainer {

    componentName = 'questionResult';

    _render() {
        return (
            <QsPreview data = { { ...mockData.data, preview: false } } />
        );
    }
}

export default questionResult
